import Accordian from 'components/styles/general-elements/Accordian';
import Divider from 'components/styles/general-elements/Divider';
import Title from 'components/styles/Title';
import React from 'react';
import { CAContent, CADivider, CAHeader, CALead, ContentArticle, ContentProps } from './ContentTemplate';

interface ContentListTemplateProps extends ContentProps {
    style: 'regular' | 'faq';
}

const ContentListTemplate: React.FC<ContentListTemplateProps> = ({ style, contentObj, className, color }) => {
    const { header, lead, content, menu } = contentObj;
    const list = lead.map((el, idx) => {
        return {
            title: el.text,
            content: !!content[idx] ? content[idx].text : '',
        };
    });
    return (
        <ContentArticle className={`${className || ''} content-list`}>
            {header.length > 0 && (
                <Title as="h2" key={header[0].text.slice(-12)} className="heading-4">
                    {header[0].text}
                </Title>
            )}

            <Accordian items={list} />
            {header[0].text.length > 0 && <Divider size="s" />}
        </ContentArticle>
    );
};

export default ContentListTemplate;
